export const checkOnlineStatus = async () => {
  try {
    const online = await fetch('assets/icons/small.jpg', { cache: 'no-cache' })
    return online.status >= 200 && online.status < 300
  } catch (err) {
    return false
  }
}
